import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { interval } from 'rxjs';
import { ToasterMessageService } from '../topbar-toaster/toaster-message.service';

@Injectable({
  providedIn: 'root'
})
export class VersioncheckService {

  private http = inject(HttpClient);
  private toastService = inject(ToasterMessageService);

  private currentVersion: string | null = null;

  startVersionChecking() {

    this.http.get<any>('/version.json?t=' + Date.now())
      .subscribe(res => {
        this.currentVersion = res.version;
      });

    interval(30000).subscribe(() => {
      this.checkVersion();
    });
  }

  private checkVersion() {

    this.http.get<any>('/version.json?t=' + Date.now())
      .subscribe(res => {

        if (
          this.currentVersion &&
          this.currentVersion !== res.version
        ) {
          this.showUpdatePopup();
        }

      });
  }

  private showUpdatePopup() {
      this.toastService.reloadMessage("New version available. Please reload the page",true,0,true);
    // let seconds = 10;

    // const confirmed = window.confirm(
    //   `New version available.\nApplication will refresh in ${seconds} seconds.`
    // );

    // if (confirmed) {
    //   location.reload();
    //   return;
    // }

    // const timer = setInterval(() => {
    //   seconds--;

    //   if (seconds <= 0) {
    //     clearInterval(timer);
    //     location.reload();
    //   }

    // }, 1000);
  }
}
